import type { SceneMeta } from '@/types';

export const fccMeta: SceneMeta = {
  id: 'fcc',
  name: '催化裂化装置',
  shortName: 'FCC',
  icon: '🛢️',
  thumbnail: '/scenes/fcc.jpg',
  description: '炼厂核心装置，含反应-再生双器、分馏塔与机泵系统',
  designSize: { width: 1200, height: 680 },
  primaryColor: '#f97316',  // 橙色，象征催化裂化高温反应
  difficulty: 'advanced',
  status: 'available',
};
